export { default } from './TableCell';